import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { shiftTotalSchema } from '../types';

export const receiveShiftTotal = createReceive('shift-total', zodContract(shiftTotalSchema));
